import { Box, Grid, Stack, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRequest } from "../../utils/ApiUtil";
import { apiEndpoints } from "../../constants/ApplicationConstants";
import { setPageMessage, setProcessing } from "../../store/ApplicationStore";
import { storeAdminAuditLogs } from "../../store/AdminInsightsStore";
import { AdminAuditSerializer } from "../../serializers/AdminAuditSerializer";
import { Refresh, VerifiedUser } from "@mui/icons-material";
import { useHandleError } from "../others/ErrorScreen";

export default function AdminAuditScreen(){
    const { logs } = useSelector(state => state.admininsights);

    const handleError=useHandleError()
    const dispatch= useDispatch();

    const fetchAdminAudit = useCallback(async ()=>{
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.adminAudit);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const fetchedLogs= response.data&&response.data.map((log)=>{
                    return AdminAuditSerializer(log)
                }).filter(obj=>obj)
                dispatch(storeAdminAuditLogs(fetchedLogs));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }
        catch(err){
           handleError(err)
        }
    },[dispatch,handleError]);

    useEffect(()=>{
        if(!logs){
            fetchAdminAudit();
        }
    },[dispatch, logs, fetchAdminAudit]);

    return(
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box>
                        <Box display='flex' >
                            <VerifiedUser sx={{marginRight: '1rem',marginTop:'0.3rem'}}/>
                            <Stack direction='row' alignItems='center'>
                            <Box>
                                <Typography variant='h5'>Admin Activity Logs</Typography>
                                <Typography sx={{opacity: '0.6'}} variant='subtitle2'>Activities list performed by the Admin.</Typography>
                            </Box>
                            <Refresh onClick={()=>{fetchAdminAudit()}} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                            </Stack >
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {logs&&logs.map((log)=>{
                        return  <Box key={log.id}  sx={{boxShadow: 3, p: 2, borderLeft: '5px solid'}}>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography fontWeight='bold' sx={{opacity: '0.8'}} variant='subtitle2'>Action</Typography>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Typography sx={{opacity: '0.8', marginLeft: '2rem',wordBreak:'break-word'}} variant='subtitle2'>{log.message}</Typography>
                                        </Grid>
                                    </Grid> 
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography fontWeight='bold' sx={{opacity: '0.8'}} variant='subtitle2'>Action By</Typography>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Typography sx={{opacity: '0.8', marginLeft: '2rem',wordBreak:'break-word'}} variant='subtitle2'>{log.admin}</Typography>
                                        </Grid>
                                    </Grid> 
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography fontWeight='bold' sx={{opacity: '0.8'}} variant='subtitle2'>Action Date</Typography>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Typography sx={{opacity: '0.8', marginLeft: '2rem',wordBreak:'break-word'}} variant='subtitle2'>{new Date(log.insertDate).toLocaleString('en-US',{weekday: 'short',year: 'numeric',month: 'short',day: 'numeric',hour: 'numeric',minute: 'numeric',second: 'numeric', timeZoneName: 'short'})}</Typography>
                                        </Grid>
                                    </Grid>                
                                </Box>
                    })}
                </Grid>
            </Grid>
        </Box>
    )
}